import { ApplicationConfig } from '@angular/core';
import { PreloadAllModules, provideRouter, withDebugTracing, withHashLocation, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withDebugTracing(), withRouterConfig({paramsInheritanceStrategy: 'always'})),
    provideClientHydration(),
    provideHttpClient(),
    provideAnimations(), // required animations providers
    provideToastr({timeOut: 3000, preventDuplicates: true }), // Toastr providers
  ]
};
